import UserRoles from "@/api/UserRoles";
import ReportOptions from "@/api/ReportOptions";
import Report from "@/api/Report";
import Impersonate from "@/api/Impersonate";
import News from "@/api/News";

class Manager {
  constructor() {
    this.userRoles = UserRoles;
    this.reportOptions = ReportOptions;
    this.report = Report;
    this.impersonate = Impersonate;
    this.news = News;
  }
}

export default Manager;
